SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View')
SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportOrderFoodServiceActionView extends SupportServiceActionsBaseView
  tag: 'td'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    unless @shouldShowPopup()
      @addHref @getUrlForVoucher @order.groupons[0]

  toHash: ->
    button_title = @getSingleActionTitle()
    hash =
      service_action_id : "order_food",
      service_action : button_title
    if @isSingleGroupon()
      @extendSingleGrouponParams(hash)
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder
    if @shouldShowPopup()
      args =
        orders: @order
        serviceActionName: 'order_food'
        singleActionButtonCallback: @getUrlForVoucher
        showgroupActionButton: false
        title: @getSingleActionTitle()
        singleActionButtonName: @getSingleActionTitle()
        showAlertMessage: false
      multipleQtyPopup = new SupportMultipleQtyPopupView(args)
      multipleQtyPopup.render()
    return true

  getSingleActionTitle: () ->
    I18n.t("js.modules.support.order_food")

  shouldShowPopup: () ->
    (not @isSingleGroupon())

  isSingleGroupon: () ->
    (@order.groupons.length is 1)

  getUrlForVoucher: (groupon) ->
    return "/biz/locations/delivery-takeout?merchantId=#{@order.merchant?.uuid}&voucherId=#{groupon.id}"

  addHref : (url) ->
    @$el.find('#order_food').attr('href', url)

  events :
    "click #order_food"  : "actionHandler"

module.exports = SupportOrderFoodServiceActionView
